import { useMemo } from "react";

import { GenericNoteItem } from "@accurx/concierge/types";

import { PreviewSummaryTemplate } from "../../PreviewSummaryTemplate";

export type GenericNoteProps = {
    conversationItem: GenericNoteItem;
};

export const GenericNote = ({ conversationItem }: GenericNoteProps) => {
    /**
     * More info on why we have using this approach here: https://github.com/Accurx/rosemary/pull/20395/files#r1314826070
     */
    const summary = useMemo(
        () =>
            conversationItem.markdown
                .replaceAll("\\\n", " ")
                .replaceAll("**", ""),
        [conversationItem.markdown],
    );
    const displayName =
        conversationItem.createdBy.type === "Patient"
            ? "Patient"
            : conversationItem.fallbackSenderDisplayName;
    return (
        <PreviewSummaryTemplate note={displayName} messageSummary={summary} />
    );
};
